module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "exchanges column"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.title) + "\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "exchange-part row"
  }, [_c('div', {
    staticClass: "ctn-list-exchange column"
  }, [_c('div', {
    staticClass: "lists-exchange"
  }, [_vm._l((_vm.threads), function(thread, key) {
    return _c('div', {
      key: key,
      staticClass: "exchange",
      class: {
        active: thread === _vm.currentThread
      },
      on: {
        "click": function($event) {
          return _vm.setCurrentThread(thread.id)
        }
      }
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(thread.created_at) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "subject"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(thread.title) + "\n\t\t\t\t\t")])])
  }), _vm._v(" "), (!_vm.threads.length) ? _c('div', {
    staticClass: "exchange"
  }, [_vm._v("\n\t\t\t\t\tIl n'y a pas encore de conversation.\n\t\t\t\t")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "exchange-content column"
  }, [_c('div', {
    staticClass: "content-head row"
  }, [_c('div', {
    staticClass: "subject"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.currentThread.title) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.emitNewThread
    }
  }, [_vm._v("\n\t\t\t\t\t\tNouveau message\n\t\t\t\t\t")]), _vm._v(" "), (_vm.currentThreadId) ? _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.emitNewMessage
    }
  }, [_vm._v("\n\t\t\t\t\t\tRépondre\n\t\t\t\t\t")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content-body"
  }, [_vm._l((_vm.currentThread.messages), function(message, key) {
    return _c('div', {
      key: key,
      staticClass: "message row"
    }, [_c('div', {
      staticClass: "ctn-profile-picture"
    }, [_c('img', {
      directives: [{
        name: "img-detect",
        rawName: "v-img-detect"
      }],
      attrs: {
        "src": _vm.resolveImg(message.user),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "body-message"
    }, [_c('div', {
      staticClass: "head-message row"
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(message.created_at) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(message.user.first_name) + " " + _vm._s(message.user.last_name) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), (message.body) ? _c('p', {
      staticClass: "inner-body-message"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(message.body) + "\n\t\t\t\t\t\t")]) : _c('p', {
      staticClass: "inner-body-message"
    }, [_c('span', [_vm._v(_vm._s(message.appointment_detail))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Jour(s) souhaités : " + _vm._s(_vm._f("arrayDisplay")(message.appointment_day)))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Moment(s) de la journée souhaités : " + _vm._s(_vm._f("arrayDisplay")(message.appointment_moment)))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Sujet(s) souhaités : " + _vm._s(_vm._f("arrayDisplay")(message.appointment_subject)))]), _c('br')])])])
  }), _vm._v(" "), (!_vm.currentThread.messages.length) ? _c('div', {
    staticClass: "take-place row"
  }, [_vm._v("\n\t\t\t\t\tIl n'y a aucun message\n\t\t\t\t")]) : _vm._e()], 2)])]), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.showNewThread,
      "data": _vm.dataNewThread,
      "content": _vm.modalNewThread
    },
    on: {
      "close": function($event) {
        _vm.showNewThread = false
      }
    }
  }), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.showNewMessage,
      "data": _vm.dataNewMessage,
      "content": _vm.modalNewMessage
    },
    on: {
      "close": function($event) {
        _vm.showNewMessage = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c3e1bec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/chat.vue
// module id = 1125
// module chunks = 0